import React from "react";
import { Link } from "react-router-dom"; // Link import edildi
import {
  FaHome, FaChartBar, FaVideo, FaCrosshairs, FaPlus, FaShareAlt, FaSun, FaMoon
} from "react-icons/fa";

const items = [
  { id: "home", icon: <FaHome size={28} />, label: "Anasayfa", route: "/" },
  { id: "stats", icon: <FaChartBar size={28} />, label: "İstatistikler", route: "/stats" },
  { id: "stream", icon: <FaVideo size={28} />, label: "Yayın", route: "/stream" },
  { id: "crosshairs", icon: <FaCrosshairs size={28} />, label: "Crosshair’lar", route: "/crosshairs" },
  // "Upload" etiketli öğenin rotası CrosshairGenerator sayfasına yönlendirildi
  { id: "upload", icon: <FaPlus size={28} />, label: "Crosshair Oluştur", route: "/crosshairs/generator" },
  { id: "socials", icon: <FaShareAlt size={28} />, label: "Sosyal", route: "/socials" },
];

// setDarkMode prop'u kaldırıldı, isLive prop'u eklendi
export default function FloatingSidebar({ darkMode, palette, isLive }) {
  return (
    <>
      <div
        className="floating-sidebar"
        style={{
          position: "fixed",
          top: "50%",
          left: 28,
          transform: "translateY(-50%)",
          zIndex: 9999,
          borderRadius: 28,
          boxShadow: "0 2px 20px 0 #0005",
          background: darkMode ? palette.dark : "#181d2fd7",
          padding: "17px 0",
          width: 66,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
          backdropFilter: "blur(4px)",
        }}
      >
        <style>{`
          .fs-btn {
            width: 48px;
            height: 48px;
            margin-bottom: 10px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: transparent;
            border: none;
            cursor: pointer;
            transition: background 0.18s, transform 0.13s;
            position: relative; /* Needed for absolute positioning of LED */
            font-size: 28px;
            color: ${palette.text};
          }
          .fs-btn:hover {
            background: ${palette.soft};
            transform: scale(1.15);
            z-index: 2;
          }
          .fs-btn .fs-label {
            position: absolute;
            left: 54px;
            top: 50%;
            transform: translateY(-50%);
            background:rgb(5, 22, 31);
            color: #fff;
            padding: 9px 18px 9px 18px;
            border-radius: 16px;
            font-size: 17px;
            font-weight: 700;
            box-shadow: 0 2px 8px 0 #0002;
            opacity: 0;
            pointer-events: none;
            white-space: nowrap;
            transition: opacity 0.13s, left 0.13s;
          }
          .fs-btn:hover .fs-label {
            opacity: 1;
            left: 70px;
            pointer-events: auto;
          }
          @keyframes blinkRedLedSidebar {
            0%, 100% { background-color: #FF6B6B; box-shadow: 0 0 2px #FF6B6B; } /* Lighter Red */
            50% { background-color: #FF0000; box-shadow: 0 0 5px #FF0000, 0 0 8px #FF0000; } /* Brighter Red */
          }
          .sidebar-live-led {
            width: 10px; /* Smaller LED for sidebar */
            height: 10px;
            border-radius: 50%;
            animation: blinkRedLedSidebar 1.5s infinite;
            position: absolute; /* Position relative to the button */
            top: 5px; /* Adjust as needed */
            right: 5px; /* Adjust as needed */
            border: 1px solid rgba(255, 255, 255, 0.7); /* Optional: white border for better visibility */
          }
        `}</style>
        {/* Tema butonu kaldırıldı */}

        {items.map(item => (
          <Link
            key={item.id}
            to={item.route}
            className="fs-btn"
          >
            <span style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 28,
              position: "relative", // For LED positioning if needed directly on icon span
            }}>
              {item.icon}
              {item.id === "stream" && isLive && (
                <span className="sidebar-live-led"></span>
              )}
            </span>
            <span className="fs-label">
              {item.label}
            </span>
          </Link>
        ))}
      </div>
    </>
  );
}
